<template>
  <app-page form class="workspace">
    <h1 class="title mb-4">支払方法を入力して下さい</h1>

    <card-book-car class="mb-4"/>

    <v-card>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="onSubmit"
      >
        <v-card-text class="pb-0">
          <v-radio-group
            v-model="paymethod"
            mandatory
          >
            <v-radio
              dense hide-details class="mt-0 pt-0"
              label="予約時にクレジットカードで支払う"
              :value="PAY_CARD"
            />

            <v-radio
              dense hide-details class="mt-0 pt-0"
              label="現地で支払う（現金/クレジットカード/PayPay）"
              :value="PAY_SPOT"
            />
          </v-radio-group>

          <div v-show="paymethod === PAY_CARD">
            <v-input
              class="c-card-input"
              label="カード番号"
            >
              <div id="card-number"/>
            </v-input>

            <v-input
              class="c-card-input"
              label="有効期限"
            >
              <div id="card-expire"/>
            </v-input>

            <v-input
              class="c-card-input"
              label="セキュリティコード"
            >
              <div id="card-cvc"/>
            </v-input>
          </div>
        </v-card-text>

        <v-card-actions class="px-4">
          <v-spacer/>
          <v-btn type="submit" color="primary" :disabled="!completed" :loading="running">次へ</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </app-page>
</template>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.c-card-input {
  padding-top: 12px;
  margin-top: 4px;

  .v-label {
    left: 0px !important;
    right: auto !important;
    position: absolute !important;
    transform-origin: top left;
    transform: translateY(-18px) scale(0.75) !important;
  }

  .StripeElement {
    $border-color: map-get($material-light, 'dividers');

    width: 100%;
    padding-bottom: 4px;
    border-bottom: solid 1px $border-color;
  }
}
</style>

<script>
import ShopBase from '@/app/special/mixins/ShopBase'
import CardBookCar from '../BookComponents/CardBookCar'
import * as C from '@/app/special/consts'
import { mapState, mapGetters, mapMutations } from 'vuex'

const Stripe = window.Stripe

const elemStyles = {
  base: {
    color: '#32325d',
    fontFamily: 'Arial, sans-serif',
    fontSmoothing: 'antialiased',
    fontSize: '16px',
    '::placeholder': {
      color: 'rgba(0, 0, 0, 0.6)'
    }
  },
  invalid: {
    fontFamily: 'Arial, sans-serif',
    color: '#fa755a',
    iconColor: '#fa755a'
  }
}

export default {
  name: 'BookPay',
  mixins: [
    ShopBase('摘要')
  ],
  components: {
    CardBookCar
  },
  data: () => ({
    PAY_SPOT: C.PAY_SPOT,
    PAY_CARD: C.PAY_CARD,

    // 支払方法
    paymethod: C.PAY_CARD,

    cardNumber: {
      el: null,
      status: false
    },
    cardExpire: {
      el: null,
      status: false
    },
    cardCvc: {
      el: null,
      status: false
    },

    valid: true,
    running: false,
    cardError: '',

    stripe: null
  }),
  computed: {
    ...mapState('book', {
      s_paymethod: state => state.paymethod
    }),

    ...mapGetters('book', [
      'bookCharge'
    ]),

    ...mapGetters('shop', [
      'm_stripeKey'
    ]),

    ...mapGetters('login', [
      'userName'
    ]),

    completed () {
      if (this.paymethod === C.PAY_SPOT) {
        return true
      }
      return this.cardNumber.status && this.cardExpire.status && this.cardCvc.status
    }
  },
  created () {
    this.addFetcher(() => this.fetch())
  },
  methods: {
    ...mapMutations('book', [
      'setBookPayMethod'
    ]),

    fetch () {
      this.paymethod = this.s_paymethod

      this.stripe = Stripe(this.m_stripeKey)
      const elements = this.stripe.elements()

      this.cardNumber = this.createCardNumber(elements)
      this.cardExpire = this.createCardExpire(elements)
      this.cardCvc = this.createCardCvc(elements)

      return true
    },

    createCardNumber (elements) {
      const el = elements.create('cardNumber', {
        style: elemStyles
      })
      el.mount('#card-number')
      el.addEventListener('change', event => {
        this.cardNumber.status = event.complete
        if (event.complete) {
          this.cardExpire.el.focus()
        }
      })

      return { el, status: false }
    },

    createCardExpire (elements) {
      const el = elements.create('cardExpiry', {
        style: elemStyles
      })
      el.mount('#card-expire')
      el.addEventListener('change', event => {
        this.cardExpire.status = event.complete
        if (event.complete) {
          this.cardCvc.el.focus()
        }
      })

      return { el, status: false }
    },

    createCardCvc (elements) {
      const el = elements.create('cardCvc', {
        style: elemStyles
      })
      el.mount('#card-cvc')
      el.addEventListener('change', event => {
        this.cardCvc.status = event.complete
      })

      return { el, status: false }
    },

    async onSubmit () {
      if (!this.$refs.form.validate()) {
        return
      }

      let ok = false
      let paytoken = ''
      this.running = true
      do {
        if (this.paymethod !== C.PAY_CARD) {
          ok = true
          break
        }

        // token を作成する
        const result = await this.stripe.createToken(this.cardNumber.el, {
          name: this.userName
        })
        if (result.error) {
          this.cardError = result.error.message
          break
        }
        paytoken = result.token.id

        ok = true
      } while (false)
      this.running = false

      if (!ok) {
        return
      }

      // 支払方法を保存する
      this.setBookPayMethod({
        paymethod: this.paymethod,
        paytoken: paytoken
      })

      // 次のページへ
      this.$router.push({ name: 'book-confirm' })
    }
  }
}
</script>
